import React, { useEffect, useState } from "react";

// Throttle function to limit event handling frequency
const throttle = (func, limit) => {
  let lastFunc;
  let lastRan;

  return function (...args) {
    const context = this;
    if (!lastRan) {
      func.apply(context, args);
      lastRan = Date.now();
    } else {
      if (lastFunc) clearTimeout(lastFunc);
      lastFunc = setTimeout(() => {
        if (Date.now() - lastRan >= limit) {
          func.apply(context, args);
          lastRan = Date.now();
        }
      }, limit - (Date.now() - lastRan));
    }
  };
};

const ActivityMonitor = ({ setCurrentPage }) => {
  const [inactivityTimer, setInactivityTimer] = useState(null);

  // Function to handle events
  const handleEvent = () => {
    // Log activity
    // Reset inactivity timer
    if (inactivityTimer) {
      clearTimeout(inactivityTimer);
    }
    setInactivityTimer(
      setTimeout(() => {
        setCurrentPage("home");
      }, 60 * 1000) // 1 minute of inactivity will send to Home
    );
  };

  // Throttle function to limit event handling frequency
  const throttledHandleEvent = throttle(handleEvent, 65 * 1000);

  // Set up event listeners
  useEffect(() => {
    // Add event listeners
    window.addEventListener("click", throttledHandleEvent);
    window.addEventListener("touchstart", throttledHandleEvent); // For taps
    window.addEventListener("keydown", throttledHandleEvent);

    // Clean up event listeners on component unmount
    return () => {
      window.removeEventListener("click", throttledHandleEvent);
      window.removeEventListener("touchstart", throttledHandleEvent);
      window.removeEventListener("keydown", throttledHandleEvent);
      if (inactivityTimer) {
        clearTimeout(inactivityTimer);
      }
    };
  }, [throttledHandleEvent, inactivityTimer, setCurrentPage]);

  return null; // This component does not render anything
};

export default ActivityMonitor;
